import React, { useEffect, createElement } from 'react';
import { motion } from 'framer-motion';
declare global {
  namespace JSX {
    interface IntrinsicElements {
      'wistia-player': React.DetailedHTMLProps<React.HTMLAttributes<HTMLElement> & {
        'media-id'?: string;
        aspect?: string;
      }, HTMLElement>;
    }
  }
}
export function Hero() {
  useEffect(() => {
    const playerScriptId = 'wistia-player-script';
    const embedScriptId = 'wistia-embed-script-d1wtded5b5';
    if (!document.getElementById(playerScriptId)) {
      const s1 = document.createElement('script');
      s1.id = playerScriptId;
      s1.src = 'https://fast.wistia.com/player.js';
      s1.async = true;
      document.body.appendChild(s1);
    }
    if (!document.getElementById(embedScriptId)) {
      const s2 = document.createElement('script');
      s2.id = embedScriptId;
      s2.src = 'https://fast.wistia.com/embed/d1wtded5b5.js';
      s2.async = true;
      s2.type = 'module';
      document.body.appendChild(s2);
    }
    // Wistia E-v1 API (for video event hooks like onReady / bind("end"))
    const ev1ScriptId = 'wistia-ev1-script';
    if (!document.getElementById(ev1ScriptId)) {
      const s3 = document.createElement('script');
      s3.id = ev1ScriptId;
      s3.src = 'https://fast.wistia.com/assets/external/E-v1.js';
      s3.async = true;
      document.body.appendChild(s3);
    }
    // UTM attribution + redirect on video end
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const w = window as any;
    w._wq = w._wq || [];
    w._wq.push({
      id: '_all',
      onReady: function (video: any) {
        const baseTypeformURL = 'https://yourname.typeform.com/to/XXXXXX';
        const urlParams = new URLSearchParams(window.location.search);
        // Check if traffic came from Google Ads
        // Google Ads click = either gclid present OR utm_source=adwords
        const isGoogleAds = urlParams.has('gclid') || urlParams.has('wbraid') || urlParams.has('gbraid') || urlParams.get('utm_source') === 'adwords';
        let finalParams: string;
        if (isGoogleAds) {
          // Pass through all the Google Ads UTMs as-is
          finalParams = window.location.search;
        } else {
          // Default to Indeed attribution
          finalParams = '?utm_source=indeed&utm_medium=job_board&utm_campaign=sales_missoula';
        }
        video.bind('end', function () {
          const destination = baseTypeformURL + finalParams;
          let redirected = false;
          const goNow = () => {
            if (redirected) return;
            redirected = true;
            window.location.href = destination;
          };
          // Fire Google Ads conversion, then redirect via event_callback
          // so the beacon is guaranteed to send before navigation.
          if (typeof w.gtag === 'function') {
            w.gtag('event', 'conversion', {
              send_to: 'AW-18158826329/dh7XCIj8lqwcENnm5tJD',
              value: 1.0,
              currency: 'USD',
              event_callback: goNow
            });
            // Fallback: if gtag doesn't fire the callback within 1.5s, redirect anyway
            setTimeout(goNow, 1500);
          } else {
            goNow();
          }
        });
      }
    });
  }, []);
  return <section className="relative pt-20 pb-16 sm:pt-24 sm:pb-20" data-id="element-45">
      <div className="absolute inset-0 z-0" style={{
      backgroundImage: 'url(https://images.unsplash.com/photo-1560518883-ce09059eeffa?w=1600&q=80)',
      backgroundSize: 'cover',
      backgroundPosition: 'center'
    }} data-id="element-46">
        <div className="absolute inset-0 bg-charcoal bg-opacity-90" data-id="element-47"></div>
      </div>

      <div className="relative z-10 max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 w-full" data-id="element-48">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6
      }} className="text-center mb-10" data-id="element-49">
          <div className="inline-block px-4 py-2 bg-maroon text-white text-sm font-bold tracking-wider mb-6" data-id="element-50">
            NOW HIRING — MISSOULA, MT
          </div>

          <h1 className="font-display text-5xl sm:text-6xl lg:text-7xl text-white leading-[1.05] mb-6" data-id="element-51">
            Watch this short video from NTY's co-founder.
            <span className="block text-maroon" data-id="element-52">Then apply.</span>
          </h1>

          <p className="text-lg sm:text-xl text-gray-300 max-w-2xl mx-auto leading-relaxed" data-id="element-53">
            A six-figure income opportunity for the right person — no degree, no
            fancy resume required. Just grit, coachability, and a willingness to
            compete. Watch the video to see if you're a fit.
          </p>
          <p className="text-xs text-gray-500 max-w-2xl mx-auto mt-4 italic leading-relaxed" data-id="element-54">
            Income potential referenced reflects individual past results and is
            not a guarantee or projection of future earnings. Compensation is
            commission-based with no minimum guaranteed income. Your results
            will vary.
          </p>
        </motion.div>

        <motion.div id="vsl-video" initial={{
        opacity: 0,
        scale: 0.97
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.6,
        delay: 0.2
      }} className="relative max-w-4xl mx-auto" data-id="element-55">
          <div className="rounded-lg overflow-hidden shadow-2xl border border-gray-700 bg-charcoal" data-id="element-56">
            <wistia-player media-id="d1wtded5b5" aspect="1.7777777777777777" data-id="element-57"></wistia-player>
          </div>
          <p className="text-center text-gray-400 text-sm mt-4 font-medium tracking-wide" data-id="element-58">
            A message from Brock, Co-Founder · ~5 min
          </p>
        </motion.div>

        <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} transition={{
        duration: 0.6,
        delay: 0.4
      }} className="mt-14 pt-8 border-t border-gray-700" data-id="element-59">
          <div className="flex flex-wrap items-center justify-center gap-x-6 gap-y-3 text-gray-400 text-sm" data-id="element-60">
            <div className="flex items-center space-x-2" data-id="element-61">
              <div className="w-2 h-2 bg-maroon rounded-full" data-id="element-62"></div>
              <span data-id="element-63">Launched mid-2024</span>
            </div>
            <div className="flex items-center space-x-2" data-id="element-64">
              <div className="w-2 h-2 bg-maroon rounded-full" data-id="element-65"></div>
              <span data-id="element-66">$1M in their first month</span>
            </div>
            <div className="flex items-center space-x-2" data-id="element-67">
              <div className="w-2 h-2 bg-maroon rounded-full" data-id="element-68"></div>
              <span data-id="element-69">4 offices nationwide</span>
            </div>
            <div className="flex items-center space-x-2" data-id="element-70">
              <div className="w-2 h-2 bg-maroon rounded-full" data-id="element-71"></div>
              <span data-id="element-72">On pace for $20M this year</span>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}